{
	"email_successfully_sent": "The email was successfully sent.",
	"email_transporter_not_ready": "The email transporter is not ready."
}
